var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "390.356px",
    height: "497.082px",
    viewBox: "0 0 390.356 497.082",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SurveyReel-UK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Target_logo",
    fill: "#CC0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.252,322.471 C125.013,322.471 67.2,264.75 67.2,193.499 C67.2,122.119 125.013,64.44 196.252,64.44 C267.553,64.44 325.294,122.119 325.294,193.499 C325.294,264.75 267.553,322.471 196.252,322.471 M196.252,0 C89.456,0 2.853,86.625 2.853,193.499 C2.853,300.291 89.456,386.889 196.252,386.889 C303.094,386.889 389.833,300.291 389.833,193.499 C389.833,86.625 303.094,0 196.252,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.252,127.192 C159.645,127.192 129.984,156.781 129.984,193.499 C129.984,230.096 159.644,259.773 196.252,259.773 C232.894,259.773 262.619,230.095 262.619,193.499 C262.619,156.782 232.894,127.192 196.252,127.192",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "21.331 437.357 -3.55271368e-15 437.357 -3.55271368e-15 424.193 58.314 424.193 58.314 437.357 36.983 437.357 36.983 495.373 21.331 495.373 21.331 437.357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.536,495.373 L67.379,495.373 L72.966,479.518 L99.583,479.518 L104.968,495.373 L121.214,495.373 L94.597,424.193 L78.551,424.193 L51.536,495.373 M86.325,441.732 L86.521,441.732 L95.489,467.855 L77.06,467.855 L86.325,441.732 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.387,495.373 L143.046,495.373 L143.046,467.561 L158.687,467.561 C166.57,467.561 169.455,470.848 170.549,478.321 C171.356,484.005 171.153,490.885 173.049,495.374 L188.691,495.374 C185.903,491.388 186.006,483.003 185.703,478.519 C185.202,471.331 183.018,463.863 175.336,461.871 L175.336,461.674 C183.221,458.486 186.607,452.213 186.607,443.828 C186.607,433.07 178.526,424.197 165.77,424.197 L127.388,424.197 L127.387,495.373 M143.046,436.355 L160.195,436.355 C167.162,436.355 170.953,439.347 170.953,446.218 C170.953,453.392 167.162,456.388 160.195,456.388 L143.046,456.388 L143.046,436.355 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.802,487.293 C243.314,494.381 236.149,497.082 229.267,497.082 C207.241,497.082 194.278,480.607 194.278,460.07 C194.278,438.947 207.24,422.506 229.267,422.506 C243.817,422.506 257.579,431.477 259.278,447.613 L244.317,447.613 C242.519,439.73 236.639,435.658 229.267,435.658 C215.21,435.658 209.919,447.613 209.919,460.07 C209.919,471.939 215.21,483.896 229.267,483.896 C239.438,483.896 245.307,478.417 246.209,468.542 L230.466,468.542 L230.466,456.892 L260.365,456.892 L260.365,495.372 L250.389,495.372 L248.802,487.293",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "271.035 424.193 324.249 424.193 324.249 437.357 286.684 437.357 286.684 452.602 321.168 452.602 321.168 464.775 286.684 464.775 286.684 482.209 325.056 482.209 325.056 495.373 271.035 495.373 271.035 424.193"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "353.366 437.357 332.034 437.357 332.034 424.193 390.356 424.193 390.356 437.357 369.013 437.357 369.013 495.373 353.366 495.373 353.366 437.357"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTarget);
export default __webpack_public_path__ + "static/media/logo-target.b1759a4fe133dd3947067244c7a787f8.svg";
export { ForwardRef as ReactComponent };